export const LINK_TEXT = 'See Users without Classes'
export const MANY_USERS_DESCRIPTION_TEXT = 'Users with Classes'
export const SINGLE_USER_DESCRIPTION_TEXT = 'User with Classes'
